// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Popover from "../overlays/Popover.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as DayPickerRange from "./DayPickerRange.res.js";
import * as DateRangePicker from "./DateRangePicker.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OverlayTriggerView from "../overlays/OverlayTriggerView.res.js";

function dateRangetoPartialDateRange(value) {
  if (value !== undefined) {
    return [
      Primitive_option.some(value[0]),
      Primitive_option.some(value[1])
    ];
  } else {
    return [
      undefined,
      undefined
    ];
  }
}

function formatDateRange(value) {
  return I18n.dateTimeFormat(undefined, "medium", undefined, undefined, undefined, undefined, undefined, undefined, undefined, value[0]) + ` → ` + I18n.dateTimeFormat(undefined, "medium", undefined, undefined, undefined, undefined, undefined, undefined, undefined, value[1]);
}

let values = [
  "Today",
  "Yesterday",
  "CurrentWeek",
  "LastWeek",
  "CurrentMonth",
  "LastMonth",
  "CurrentYear",
  "LastYear"
];

function isCustomOrNotDefined(value) {
  if (typeof value !== "object") {
    return value === "NotDefined";
  } else {
    return true;
  }
}

function toString(notDefinedPlaceholder, value) {
  if (typeof value !== "object") {
    switch (value) {
      case "Today" :
        return I18n.t("Today");
      case "Yesterday" :
        return I18n.t("Yesterday");
      case "CurrentWeek" :
        return I18n.t("Current week");
      case "LastWeek" :
        return I18n.t("Last week");
      case "CurrentMonth" :
        return I18n.t("Current month");
      case "LastMonth" :
        return I18n.t("Last month");
      case "CurrentYear" :
        return I18n.t("Current year");
      case "LastYear" :
        return I18n.t("Last year");
      case "NotDefined" :
        return notDefinedPlaceholder;
    }
  } else {
    let match = value._0;
    let startDate = match[0];
    if (startDate === undefined) {
      return I18n.t("Custom");
    }
    let endDate = match[1];
    if (endDate !== undefined) {
      if (DateHelpers.isSameDay(startDate, endDate)) {
        return I18n.dateTimeFormat(undefined, "medium", undefined, undefined, undefined, undefined, undefined, undefined, undefined, startDate);
      } else {
        return formatDateRange([
          startDate,
          endDate
        ]);
      }
    } else {
      return I18n.dateTimeFormat(undefined, "medium", undefined, undefined, undefined, undefined, undefined, undefined, undefined, startDate) + ` →  …`;
    }
  }
}

function toDateRange(preset) {
  let now = new Date(Date.now());
  if (typeof preset !== "object") {
    switch (preset) {
      case "Today" :
        return [
          DateHelpers.startOfDay(now),
          DateHelpers.endOfDay(now)
        ];
      case "Yesterday" :
        return [
          DateHelpers.subDays(DateHelpers.startOfDay(now), 1),
          DateHelpers.endOfDay(DateHelpers.subDays(now, 1))
        ];
      case "CurrentWeek" :
        return [
          DateHelpers.startOfWeek(now),
          DateHelpers.endOfDay(now)
        ];
      case "LastWeek" :
        return [
          DateHelpers.startOfWeek(DateHelpers.subWeeks(now, 1)),
          DateHelpers.endOfWeek(DateHelpers.subWeeks(now, 1))
        ];
      case "CurrentMonth" :
        return [
          DateHelpers.startOfMonth(now),
          DateHelpers.endOfDay(now)
        ];
      case "LastMonth" :
        return [
          DateHelpers.startOfMonth(DateHelpers.subMonths(now, 1)),
          DateHelpers.endOfMonth(DateHelpers.subMonths(now, 1))
        ];
      case "CurrentYear" :
        return [
          DateHelpers.startOfYear(now),
          DateHelpers.endOfDay(now)
        ];
      case "LastYear" :
        return [
          DateHelpers.startOfYear(DateHelpers.subYears(now, 1)),
          DateHelpers.endOfYear(DateHelpers.subYears(now, 1))
        ];
      case "NotDefined" :
        return;
    }
  } else {
    let match = preset._0;
    let startDate = match[0];
    if (startDate === undefined) {
      return;
    }
    let endDate = match[1];
    if (endDate !== undefined) {
      return [
        startDate,
        endDate
      ];
    } else {
      return;
    }
  }
}

function fromPartialDateRange(range, presets) {
  let startDateA = range[0];
  if (startDateA === undefined) {
    return "NotDefined";
  }
  let endDateA = range[1];
  if (endDateA === undefined) {
    return {
      TAG: "Custom",
      _0: range
    };
  }
  let preset = presets.find(preset => {
    let match = toDateRange(preset);
    if (match !== undefined && DateHelpers.isSameDay(startDateA, match[0])) {
      return DateHelpers.isSameDay(endDateA, match[1]);
    } else {
      return false;
    }
  });
  return Stdlib_Option.getOr(preset, {
    TAG: "Custom",
    _0: range
  });
}

function isEqual(a, b) {
  if (typeof a === "object") {
    return typeof b === "object";
  }
  switch (a) {
    case "Today" :
      if (typeof b !== "object") {
        return b === "Today";
      } else {
        return false;
      }
    case "Yesterday" :
      if (typeof b !== "object") {
        return b === "Yesterday";
      } else {
        return false;
      }
    case "CurrentWeek" :
      if (typeof b !== "object") {
        return b === "CurrentWeek";
      } else {
        return false;
      }
    case "LastWeek" :
      if (typeof b !== "object") {
        return b === "LastWeek";
      } else {
        return false;
      }
    case "CurrentMonth" :
      if (typeof b !== "object") {
        return b === "CurrentMonth";
      } else {
        return false;
      }
    case "LastMonth" :
      if (typeof b !== "object") {
        return b === "LastMonth";
      } else {
        return false;
      }
    case "CurrentYear" :
      if (typeof b !== "object") {
        return b === "CurrentYear";
      } else {
        return false;
      }
    case "LastYear" :
      if (typeof b !== "object") {
        return b === "LastYear";
      } else {
        return false;
      }
    case "NotDefined" :
      if (typeof b !== "object") {
        return b === "NotDefined";
      } else {
        return false;
      }
  }
}

let StandardPreset = {
  values: values,
  isCustomOrNotDefined: isCustomOrNotDefined,
  toString: toString,
  toDateRange: toDateRange,
  fromPartialDateRange: fromPartialDateRange,
  isEqual: isEqual
};

function SelectDateRangeFilter$Component(props) {
  let onChange = props.onChange;
  let preset = props.preset;
  let __placeholder = props.placeholder;
  let __triggerPreset = props.triggerPreset;
  let __size = props.size;
  let value = props.value;
  let size = __size !== undefined ? __size : "normal";
  let triggerPreset = __triggerPreset !== undefined ? __triggerPreset : "filter";
  let placeholder = __placeholder !== undefined ? __placeholder : "Pick a date range";
  let presets = preset.values;
  let mounted = React.useRef(false);
  let match = Popover.useTrigger(undefined, undefined, undefined);
  let popoverTriggerRef = match.ref;
  let popoverAriaProps = match.ariaProps;
  let popover = match.state;
  let match$1 = Hover.use(popoverTriggerRef, undefined, undefined);
  let match$2 = React.useState(() => DayPickerRange.defaultFocusedInput);
  let setFocusedInput = match$2[1];
  let match$3 = React.useState(() => dateRangetoPartialDateRange(value));
  let setPartialDateRange = match$3[1];
  let partialDateRange = match$3[0];
  let match$4 = React.useState(() => preset.fromPartialDateRange(partialDateRange, presets));
  let setPreset = match$4[1];
  let preset$1 = match$4[0];
  let match$5 = React.useState(() => {
    let endDate = partialDateRange[1];
    if (endDate !== undefined) {
      return endDate;
    } else {
      return new Date();
    }
  });
  let setVisibleMonth = match$5[1];
  React.useEffect(() => {
    if (mounted.current) {
      let exit = 0;
      if (value !== undefined) {
        let rangeStartDate = partialDateRange[0];
        if (rangeStartDate !== undefined) {
          let rangeEndDate = partialDateRange[1];
          if (rangeEndDate === undefined || value[0].getTime() !== rangeStartDate.getTime() || value[1].getTime() !== rangeEndDate.getTime()) {
            exit = 1;
          }
        } else {
          exit = 1;
        }
      } else if (partialDateRange[0] !== undefined || partialDateRange[1] !== undefined) {
        exit = 1;
      }
      if (exit === 1) {
        setPartialDateRange(param => dateRangetoPartialDateRange(value));
      }
    }
  }, [value]);
  React.useEffect(() => {
    if (mounted.current) {
      if (value !== undefined) {
        let startPartialDateRange = partialDateRange[0];
        if (startPartialDateRange !== undefined) {
          let endPartialDateRange = partialDateRange[1];
          if (endPartialDateRange !== undefined && (value[0].getTime() !== startPartialDateRange.getTime() || value[1].getTime() !== endPartialDateRange.getTime())) {
            onChange([
              startPartialDateRange,
              endPartialDateRange
            ]);
          }
        } else if (partialDateRange[1] !== undefined) {
          
        } else {
          onChange(undefined);
        }
      } else {
        let startPartialDateRange$1 = partialDateRange[0];
        if (startPartialDateRange$1 !== undefined) {
          let endPartialDateRange$1 = partialDateRange[1];
          if (endPartialDateRange$1 !== undefined) {
            onChange([
              startPartialDateRange$1,
              endPartialDateRange$1
            ]);
          }
        }
      }
      let match = preset.toDateRange(preset$1);
      let exit = 0;
      if (match !== undefined) {
        let startB = partialDateRange[0];
        if (startB !== undefined) {
          let endB = partialDateRange[1];
          if (endB === undefined || match[0].getTime() !== startB.getTime() || match[1].getTime() !== endB.getTime()) {
            exit = 1;
          }
        } else {
          exit = 1;
        }
      } else {
        exit = 1;
      }
      if (exit === 1) {
        setPreset(param => preset.fromPartialDateRange(partialDateRange, presets));
      }
    }
  }, [partialDateRange]);
  React.useEffect(() => {
    if (mounted.current) {
      let match = preset.toDateRange(preset$1);
      let startPartialDateRange = partialDateRange[0];
      let exit = 0;
      if (match !== undefined) {
        if (startPartialDateRange !== undefined) {
          let endPartialDateRange = partialDateRange[1];
          if (endPartialDateRange === undefined || startPartialDateRange.getTime() !== match[0].getTime() || endPartialDateRange.getTime() !== match[1].getTime()) {
            exit = 1;
          }
        } else {
          exit = 1;
        }
      }
      if (exit === 1) {
        setPartialDateRange(param => dateRangetoPartialDateRange(match));
      }
      if (!preset.isCustomOrNotDefined(preset$1)) {
        popover.close();
      }
    }
  }, [preset$1]);
  React.useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  let onDatesChange = param => {
    let endDate = param[1];
    let startDate = param[0];
    setPartialDateRange(param => [
      Stdlib_Option.map(startDate, DateHelpers.startOfDay),
      Stdlib_Option.map(endDate, DateHelpers.endOfDay)
    ]);
  };
  let onFocusChange = focusedInput => setFocusedInput(param => {
    if (focusedInput == null) {
      return DayPickerRange.defaultFocusedInput;
    } else {
      return focusedInput;
    }
  });
  let onRequestReset = param => setPartialDateRange(param => [
    undefined,
    undefined
  ]);
  let onPrevMonthClick = date => setVisibleMonth(param => date);
  let onNextMonthClick = date => setVisibleMonth(param => date);
  let onChangePreset = preset$2 => {
    setPreset(param => preset$2);
    let match = preset.toDateRange(preset$2);
    let endDate = partialDateRange[1];
    if (endDate === undefined) {
      return;
    }
    if (match === undefined) {
      return;
    }
    let nextEndDate = match[1];
    if (!DateHelpers.isSameMonth(endDate, nextEndDate)) {
      return setVisibleMonth(param => nextEndDate);
    }
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Touchable.make, {
        children: JsxRuntime.jsx(OverlayTriggerView.make, {
          children: props.triggerLabelDisplay === "showDateRange" ? (
              value !== undefined ? formatDateRange(value) : placeholder
            ) : preset.toString(placeholder, preset$1),
          preset: triggerPreset,
          size: size,
          label: props.label,
          icon: "calendar",
          hovered: match$1[1],
          active: popover.isOpen,
          focused: popover.isOpen,
          highlighted: props.highlighted
        }),
        ariaProps: popoverAriaProps.triggerProps,
        onPress: param => popover.toggle(),
        ref: popoverTriggerRef
      }),
      JsxRuntime.jsx(Popover.make, {
        children: JsxRuntime.jsx(Popover.Dialog.make, {
          children: JsxRuntime.jsx(DateRangePicker.make, {
            focusedInput: match$2[0],
            visibleMonth: match$5[0],
            activePreset: preset$1,
            presets: presets,
            formatPreset: preset$2 => preset.toString(placeholder, preset$2),
            isEqualPreset: preset.isEqual,
            range: partialDateRange,
            hideResetButton: props.hideResetButton,
            hidePresets: props.hidePresets,
            onChangePreset: onChangePreset,
            onRequestReset: onRequestReset,
            onDatesChange: onDatesChange,
            onFocusChange: onFocusChange,
            onPrevMonthClick: onPrevMonthClick,
            onNextMonthClick: onNextMonthClick
          }),
          ariaProps: popoverAriaProps.overlayProps
        }),
        triggerRef: popoverTriggerRef,
        state: {
          isOpen: popover.isOpen,
          close: popover.close,
          toggle: popover.toggle
        },
        placement: "bottom start",
        modal: false
      })
    ]
  });
}

function SelectDateRangeFilter$Gen(props) {
  return JsxRuntime.jsx(SelectDateRangeFilter$Component, {
    value: props.value,
    label: props.label,
    size: props.size,
    triggerPreset: props.triggerPreset,
    highlighted: props.highlighted,
    placeholder: props.placeholder,
    hideResetButton: props.hideResetButton,
    hidePresets: props.hidePresets,
    preset: StandardPreset,
    onChange: props.onChange,
    triggerLabelDisplay: props.triggerLabelDisplay
  });
}

let Gen = {
  make: SelectDateRangeFilter$Gen
};

function SelectDateRangeFilter(props) {
  let triggerLabelDisplay = props.triggerLabelDisplay;
  let onChange = props.onChange;
  let preset = props.preset;
  let hidePresets = props.hidePresets;
  let hideResetButton = props.hideResetButton;
  let placeholder = props.placeholder;
  let highlighted = props.highlighted;
  let triggerPreset = props.triggerPreset;
  let size = props.size;
  let label = props.label;
  let value = props.value;
  if (preset !== undefined) {
    return JsxRuntime.jsx(SelectDateRangeFilter$Component, {
      value: value,
      label: label,
      size: size,
      triggerPreset: triggerPreset,
      highlighted: highlighted,
      placeholder: placeholder,
      hideResetButton: hideResetButton,
      hidePresets: hidePresets,
      preset: preset,
      onChange: onChange,
      triggerLabelDisplay: triggerLabelDisplay
    });
  } else {
    return JsxRuntime.jsx(SelectDateRangeFilter$Component, {
      value: value,
      label: label,
      size: size,
      triggerPreset: triggerPreset,
      highlighted: highlighted,
      placeholder: placeholder,
      hideResetButton: hideResetButton,
      hidePresets: hidePresets,
      preset: StandardPreset,
      onChange: onChange,
      triggerLabelDisplay: triggerLabelDisplay
    });
  }
}

let defaultFocusedInput = DayPickerRange.defaultFocusedInput;

let make = SelectDateRangeFilter;

export {
  formatDateRange,
  StandardPreset,
  dateRangetoPartialDateRange,
  defaultFocusedInput,
  Gen,
  make,
}
/* I18n Not a pure module */
